import { Directive } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Directive()
export abstract class PaginationCommonDirective {
    paginationForm: UntypedFormGroup;

    getCurrentPageInput() {
        return this.paginationForm.get('pageNumber');
    }

    getCorrectedPageNumber(totalPages) {
        // If the input is lower than or equal to 0
        // return the first page
        if (this.getCurrentPageInput()?.value <= 0) {
            return 1;
        }

        // If the input is higher than the total number of pages
        // return the last page
        if (this.getCurrentPageInput()?.value > totalPages) {
            return totalPages;
        }

        return this.getCurrentPageInput()?.value;
    }

    onChangePageSubmit(totalPages) {
        const pageNumber = this.getCorrectedPageNumber(totalPages);

        // Do nothing if the input field is empty
        if (pageNumber === null) {
            return;
        }

        this.changePage(pageNumber);
    }

    abstract changePage(page: number);
}
